// src/hooks/useImageUpload.ts
import { useState } from "react";
import { allowedMimeTypes } from "../constants/Chat.constants";

export const useImageUpload = (onValidFile: (file: File) => void) => {
  const [error, setError] = useState<string | null>(null);

  const handleImageUpload = (selectedFile: File | null) => {
    if (!selectedFile) return;

    if (!allowedMimeTypes.includes(selectedFile.type)) {
      setError("Ungültiges Bildformat. Erlaubt sind: jpeg, jpg, png, webp, gif.");
      resetError();
      return;
    }

    if (selectedFile.size > 20 * 1024 * 1024) {
      setError("Die Datei ist zu groß. Maximal 20 MB erlaubt.");
      resetError();
      return;
    }

    onValidFile(selectedFile);
  };

  const resetError = () => {
    setTimeout(() => setError(null), 4000);
  };

  return { handleImageUpload, error };
};